/*
============================================================
PRATHVI POWER SOLUTIONS
BACKEND URL CONFIGURATION
============================================================

IMPORTANT:
The application uses relative /api URLs.

This works in:
1. Emergent Preview
2. Code Server
3. Production deployments

Code Server's CRACO dev server proxies /api
to the local FastAPI backend on port 8000.
============================================================
*/

const rawBackendUrl =
  process.env.REACT_APP_BACKEND_URL ||
  process.env.REACT_APP_API_URL ||
  "";

/*
============================================================
NORMALIZE BACKEND URL
============================================================
*/

function normalizeBackendUrl(value) {
  let url = String(value || "").trim();

  /*
   * Empty URL is intentional.
   *
   * Axios will therefore request:
   *
   * /api/auth/login
   * /api/resources
   * /api/stats
   *
   * instead of:
   *
   * /proxy/8000/api/...
   */
  if (!url) {
    return "";
  }

  // Remove trailing slashes
  url = url.replace(/\/+$/, "");

  /*
   * API_BASE must never end with /api
   */
  url = url.replace(/\/api$/i, "");

  // Remove trailing slashes again
  url = url.replace(/\/+$/, "");

  return url;
}

/*
============================================================
EXPORT
============================================================
*/

export const API_BASE = normalizeBackendUrl(rawBackendUrl);

/*
Backward-compatible alias.
Some existing files still import BACKEND_URL.
*/

export const BACKEND_URL = API_BASE;

/*
============================================================
DEBUG
============================================================
*/

if (process.env.NODE_ENV !== "production") {
  console.log(
    "[Prathvi Power Solutions] API_BASE:",
    API_BASE || "(same-origin /api)"
  );

  console.log(
    "[Prathvi Power Solutions] BACKEND_URL:",
    BACKEND_URL || "(same-origin /api)"
  );
}